import React from "react";

const SettingModalButton = ({ label, toggle, disabled }) => {
  return (
    <div
      className={`modalSetBtn ${
        disabled !== undefined && disabled ? "disabled" : ""
      }`}
      onClick={toggle}
    >
      <label
        className={`per_btn_label1 ${
          disabled !== undefined && disabled ? "disabled_text" : ""
        }`}
      >
        {label}
      </label>
      <button
        className={
          disabled !== undefined && disabled
            ? "permit_progress_btn isDisabled"
            : !disabled
            ? "permit_progress_btn isEnabled"
            : "permit_progress_btn isEnabled"
        }
        disabled={disabled !== undefined ? disabled : false}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="16"
          viewBox="0 0 10 16"
          fill="none"
        >
          <path
            d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 0L9.88 8L1.88 16Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  );
};

export default SettingModalButton;
